import React from 'react';
import styled, { css } from 'styled-components';
const PatientIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/patient.svg';

const Container = styled.div`
  ${({ theme }) => css`
    display: grid;
    gap: 16px;
    grid-template-areas: 'image info';
    align-items: center;
    justify-content: start;
    position: relative;

    & .image {
      grid-area: image;
      height: 64px;
      width: 64px;
      border-radius: 50%;
      object-fit: cover;
    }

    & .info {
      grid-area: info;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .title {
        font-size: 16px;
        color: ${theme.colors.colorGray500};
        font-weight: 500;
      }

      .subtitle {
        margin-top: 4px;
        font-size: 14px;
        color: ${theme.colors.colorGray400};
        font-weight: 500;
      }

      .other {
        margin-top: 4px;
        font-size: 14px;
        color: ${theme.colors.blueEinstein};
        font-weight: 500;
      }
    }
  `}
`;

const CheckIcon = styled.div<{ size?: number }>`
  position: absolute;
  top: -8px;
  left: 36px;
  border-radius: 50%;
  height: ${props => props.size ?? 20}px !important;
  width: ${props => props.size ?? 20}px !important;
  background-color: #00b193;
  padding: 6px;
  object-fit: scale-down;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export interface SpecialistCardProps {
  imgSrc: string;
  title: string;
  description: string;
  otherInfo?: string;
  showCheck?: boolean;
}

export const SpecialistCard: React.FC<SpecialistCardProps> = ({ imgSrc, title, otherInfo, description, showCheck }) => {
  return (
    <Container>
      <img
        className="image"
        src={imgSrc}
        alt="Specialist"
        onError={({ currentTarget }) => {
          currentTarget.onerror = null; // prevents looping
          currentTarget.src = PatientIcon;
        }}
      />

      {showCheck && (
        <CheckIcon size={28}>
          <svg xmlns="http://www.w3.org/2000/svg" width="11.381" height="7.701" viewBox="0 0 11.381 7.701">
            <path
              id="Path"
              d="M17.838,24.857l-6.127,5.53L9,27.677"
              transform="translate(-7.727 -23.586)"
              fill="none"
              stroke="#fff"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.8"
            />
          </svg>
        </CheckIcon>
      )}
      <div className="info">
        <p className="title">{title}</p>
        {otherInfo && <p className="other">{otherInfo}</p>}
        <p className="subtitle">{description}</p>
      </div>
    </Container>
  );
};
